<style lang="stylus">
    .cloudFile-content
        padding-bottom 24px
        .cloudFile-path
            display flex
            align-items center
            margin-bottom 16px
            .item-icon
                width 16px
                height 16px
                // stroke #424242
                cursor pointer
                margin-right 8px
                color var(--svg-color-gray-42-secondary)
            >div
                display flex
                align-items center
                font-size 12px
                line-height 16px
                span
                    cursor pointer
                .to
                    margin 0 4px
                &:hover
                    font-weight 600
        .cloudFile-box
            width 466px
            height 276px
            padding 8px 6px
            border 1px solid var(--border-color-box-6)
            border-radius 6px
            overflow auto
            .cloudFile-list,.files-folders-list
                padding 8px 10px
                border-radius 6px
                &:hover,&.active
                    background var(--hover-color-common)
                img
                    margin-right 8px
                    vertical-align middle
                p
                    display inline-block
                    max-width calc(100% - 32px)
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    vertical-align middle
                    font-size 12px
                    line-height 16px
            .files-list
                display flex
                align-items center
                padding 8px 10px
                border-radius 6px
                &:hover,&.active
                    background var(--hover-color-common)
                .file-name
                    text-align left
                    width 40%;
                    img,p
                        display inline-block
                        vertical-align middle
                    img
                        margin-right 8px
                    p
                        max-width calc(100% - 32px)
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                .file-time
                    width 35%
                    text-align center
                .file-size
                    width 25%
                    text-align right
                    padding-right 14px
            .empty-box
                width 100%
                height 100%
                display flex
                flex-direction column
                justify-content center
                align-items center
                span
                    color var(--text-color-tertiary)
            .loading-box
                width 100%
                height 100%
                display flex
                justify-content center
                align-items center
                pointer-events none
                .loading-content
                    padding 12px 16px
                    background var(--bg-color-tips)
                    border-radius 8px
                    img
                        margin-right 8px
                        vertical-align middle
                        animation loadingFn .6s linear infinite
                    span
                        font-size 12px
                        line-height 16px
                        color #fff
                        vertical-align middle
    @keyframes loadingFn {
        0% {
            transform rotate(0)
        }
        50% {
            transform rotate(180deg)
        }
        100% {
            transform rotate(360deg)
        }
    }
</style>

<template>
    <Dialog
        :title="$t('title')"
        :showFooter="true"
        :mask="true"
        :extra="true"
        :disablConfirm="folderList.length === 0 && filesList.length === 0 && selectType != null"
        @ok="confirm"
        @close="cancel"
    >
        <div class="cloudFile-content">
            <div class="cloudFile-path">
                <iconSymbol class="item-icon" name="cloudFile-back" @click.native="backPath()"></iconSymbol>
                <div @click="toCloudDocuments()">
                    <span>{{ $t("cloudDocuments") }}</span>
                    <iconSymbol class="item-icon to" name="cloudFile-to"></iconSymbol>
                </div>
                <template v-if="path.length >= 2">
                    <div>
                        <span>...</span>
                        <iconSymbol class="item-icon to" name="cloudFile-to"></iconSymbol>
                    </div>
                    <!-- 显示后两个具体文件夹名 -->
                    <div v-for="(item, index) in path" v-if="index >= path.length - 2" :key="item" @click="setPath(index)">
                        <span>{{ item }}</span>
                        <iconSymbol class="item-icon to" name="cloudFile-to"></iconSymbol>
                    </div>
                </template>
                <template v-else>
                    <!-- 我的文档|星标文件|我的收藏 -->
                    <div v-if="selectType" @click="setPath()">
                        <span>{{ $t(selectType) }}</span>
                        <iconSymbol class="item-icon to" name="cloudFile-to"></iconSymbol>
                    </div>
                    <!-- 用户定义文件夹 -->
                    <div v-for="(item, index) in path" :key="item" @click="setPath(index)">
                        <span>{{ item }}</span>
                        <iconSymbol class="item-icon to" name="cloudFile-to"></iconSymbol>
                    </div>
                </template>
            </div>
            <div class="cloudFile-box">
                <div class="loading-box" v-if="loading">
                    <div class="loading-content">
                        <img src="@/app/assets/img/dialog/hyperlink/cloudFile/loading.png" alt="" />
                        <span>{{ $t("loading") }}</span>
                    </div>
                </div>
                <template v-else>
                    <template v-if="!selectType">
                        <div
                            class="cloudFile-list"
                            :class="{
                                active: activeList.name == 'cloudDocuments' && activeList.index == item.id,
                            }"
                            @click="setActivelist('cloudDocuments', item.id)"
                            v-for="item in cloudFileList"
                            @dblclick="opencloudFileList(item.id)"
                            :key="item.id"
                        >
                            <img src="@/app/assets/img/dialog/hyperlink/cloudFile/cloudFolder.svg" alt="" />
                            <p>{{ $t(item.title) }}</p>
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="folderList.length !== 0 || filesList.length !== 0">
                            <div
                                class="files-folders-list"
                                :class="{
                                    active: activeList.name == 'folder' && activeList.index == index,
                                }"
                                @click="setActivelist('folder', index)"
                                v-for="(item, index) in folderList"
                                :key="item.name"
                                @dblclick="openFolder(item)"
                            >
                                <img src="@/app/assets/img/dialog/hyperlink/cloudFile/folder.svg" alt="" />
                                <p>{{ $t(item.name) }}</p>
                            </div>
                            <!-- 文件双击直接选中 -->
                            <div
                                class="files-list"
                                :class="{
                                    active: activeList.name == 'files' && activeList.index == index,
                                }"
                                @click="setActivelist('files', index)"
                                v-for="(item, index) in filesList"
                                :key="item.name"
                                @dblclick="confirm(item)"
                            >
                                <div class="file-name">
                                    <img src="@/app/assets/img/dialog/hyperlink/cloudFile/file.svg" alt="" />
                                    <p>{{ item.name }}</p>
                                </div>
                                <div class="file-time" v-if="selectType !== 'collectFile'" :title="new Date(item.updated_at).toLocaleString()">
                                    {{ new Date(item.updated_at).toLocaleString() }}
                                </div>
                                <div class="file-size" v-if="selectType !== 'collectFile'">{{ renderSize(item.size) }}</div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="empty-box">
                                <img src="@/app/assets/img/null-icon/default-null.svg" alt="" />
                                <span>{{ $t("emptyFile") }}</span>
                            </div>
                        </template>
                    </template>
                </template>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";
    @Component({
        components: {
            Dialog,
        },
    })
    export default class CloudFile extends Vue {
        cloudFileList = [
            {
                id: 0,
                title: "cloudFile",
            },
            {
                id: 1,
                title: "starFile",
            },
            {
                id: 2,
                title: "collectFile",
            },
        ];
        path = []; // 导航栏面包屑
        folderList = [];
        filesList = [];
        // 选中的文件夹类型
        selectType: string | null = null;
        loading: boolean = false;
        activeList = {};
        clickTimer: number | null = null;

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        get params() {
            return this.userInfo && this.$store.getters.apiParam;
        }

        setActivelist(name, index) {
            const ts = this;
            clearTimeout(ts.clickTimer);
            ts.clickTimer = setTimeout(function () {
                ts.activeList = {
                    name,
                    index,
                };
                clearTimeout(ts.clickTimer);
            }, 250);
        }

        resetResult() {
            this.folderList = [];
            this.filesList = [];
        }

        toCloudDocuments() {
            this.selectType = null;
            this.path = [];
            this.resetResult();
        }

        backPath() {
            if (this.path.length !== 0) {
                this.path.pop();
                if (this.path.length == 0) {
                    this.getFloder("");
                } else {
                    let prefix = this.path.join("/") + "/";
                    this.getFloder(prefix);
                }
            } else {
                this.selectType !== null && this.toCloudDocuments(); // 回到云文档
            }
        }

        setPath(index = null) {
            if (index === null) {
                this.getFloder("");
                this.path = [];
            } else {
                let len = this.path.length - 1 - index;
                for (let i = 0; i < len; i++) {
                    this.path.pop();
                }
                let prefix = this.path.join("/") + "/";
                this.getFloder(prefix);
            }
        }

        renderSize(size) {
            let s = size / 1024 / 1000;
            if (s > 1) {
                return s.toFixed(2) + "M";
            } else {
                return (size / 1000).toFixed(0) + "KB";
            }
        }

        openFolder(item) {
            clearTimeout(this.clickTimer);
            this.path.push(item.name);
            let prefix = this.path.join("/") + "/";
            this.getFloder(prefix);
        }

        getFloder(prefix: string = "") {
            const ts = this;
            ts.loading = true;
            ts.$store
                .dispatch("getFloder", { prefix })
                .then((res) => {
                    if (ts.selectType != "cloudFile") return;
                    let folderList = res.data.data.folders || [];
                    let filesList = res.data.data.files || [];
                    folderList.map((item) => {
                        let list = item.prefix.split("/");
                        item.name = list[list.length - 2];
                    });
                    filesList = filesList.filter((item) => {
                        item.updated_at = item.lastModified;
                        if (item.key.match(/.+eddx$/)) {
                            let list = item.key.split("/");
                            let name = list[list.length - 1];
                            name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                            item.name = name;
                            return true;
                        }
                        return false;
                    });
                    filesList = ts.sortFilesByTime(filesList);
                    ts.folderList = folderList;
                    ts.filesList = filesList;
                    ts.loading = false;
                })
                .catch((err) => {
                    ts.loading = false;
                });
        }

        sortFilesByTime(list: any) {
            list = list.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
            return list;
        }

        getStartFile() {
            const ts = this;
            ts.loading = true;
            let p = {
                id: ts.userInfo.user_id,
                token: ts.userInfo.token,
                offset: 0,
                count: 20,
                platform: ts.$store.state.publicStore.runPlatform,
            };
            ts.$edApi
                .getStarList(p)
                .then((data) => {
                    if (ts.selectType != "starFile") return;
                    let list = data.data;
                    let arr = ts.filesList;
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].info) {
                            let obj = {
                                id: list[i].info.id,
                                key: list[i].info.obj,
                                size: list[i].info.size,
                                updated_at: list[i].star_date,
                                info: list[i].info,
                                name: "",
                            };
                            let nameList = obj.key.split("/");
                            let name = nameList[nameList.length - 1];
                            name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                            obj.name = name;
                            arr.push(obj);
                        }
                    }
                    ts.loading = false;
                })
                .catch((err) => {
                    ts.loading = false;
                });
        }

        getCollectFile() {
            const ts = this;
            let para = JSON.parse(JSON.stringify(ts.params));
            ts.loading = true;
            ts.$edApi
                .getLikeAndCollectWorks(Object.assign(para, { type: "collect" }))
                .then((data) => {
                    if (ts.selectType != "collectFile") return;
                    data = data.filter((item) => {
                        return item.url != null;
                    });
                    data.forEach((item) => {
                        item.name = item.title;
                    });
                    ts.filesList = data;
                    ts.loading = false;
                })
                .catch(() => {
                    ts.loading = false;
                });
        }

        opencloudFileList(id: number) {
            clearTimeout(this.clickTimer);
            switch (id) {
                case 0:
                    // 获取云文件
                    this.getFloder();
                    this.selectType = "cloudFile";
                    break;
                case 1:
                    // 获取星标文件
                    this.getStartFile();
                    this.selectType = "starFile";
                    break;
                case 2:
                    // 获取收藏文件
                    this.getCollectFile();
                    this.selectType = "collectFile";
                    break;
            }
        }

        confirm(item: any) {
            if (this.activeList && this.activeList["name"] == "files") {
                item = this.filesList[this.activeList["index"]];
            }
            if (item) {
                this.$bus.$emit("changeCloudFileUrl", {
                    item,
                    workId: this.selectType == "collectFile" && item.id,
                });
            }
            this.$store.commit("setDialogState", {
                type: "showCloudFileDialog",
                data: false,
            });
        }
        cancel() {
            this.$store.commit("setDialogState", {
                type: "showCloudFileDialog",
                data: false,
            });
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "选择云文档",
    "cloudDocuments": "云文档",
    "cloudFile": "我的文档",
    "starFile": "收藏文件",
    "collectFile": "我的收藏",
    "emptyFile": "此文件夹为空",
    "loading": "正在为您加载"
  },
  "en": {
    "title": "Choose your cloud document",
    "cloudDocuments": "Cloud Documents",
    "cloudFile": "My Documents",
    "starFile": "Starred File",
    "collectFile": "Favorites",
    "emptyFile": "This folder is empty",
    "loading": "Loading for you"
  },
  "jp": {
    "title": "クラウドフォルダを選択",
    "cloudDocuments": "クラウドファイル",
    "cloudFile": "マイドキュメント",
    "starFile": "スター付きファイル",
    "collectFile": "お気に入り",
    "emptyFile": "このフォルダは空です",
    "loading": "読み込み中"
  },
  "fr": {
    "title": "Choisir votre dossier cloud",
    "cloudDocuments": "Documents Cloud",
    "cloudFile": "Mes documents",
    "starFile": "Fichier marqué d'une étoile",
    "collectFile": "Favoris",
    "emptyFile": "Ce dossier est vide",
    "loading": "Chargement"
  },
  "de": {
    "title": "Wählen Sie Ihren Cloud-Ordner",
    "cloudDocuments": "Cloud-Dokumente",
    "cloudFile": "Meine Dokumente",
    "starFile": "Mit Sternchen als Favorit markierte Datei",
    "collectFile": "Favoriten",
    "emptyFile": "Dieser Ordner ist leer",
    "loading": "Wird geladen"
  },
  "es": {
    "title": "Elige tu carpeta en la nube",
    "cloudDocuments": "Documentos en la nube",
    "cloudFile": "Mis documentos",
    "starFile": "Archivo destacado",
    "collectFile": "Favoritos",
    "emptyFile": "Esta carpeta está vacía",
    "loading": "Cargando"
  },
  "pt": {
    "title": "Escolha sua pasta de nuvens",
    "cloudDocuments": "Documentos em Nuvem",
    "cloudFile": "Meus documentos",
    "starFile": "Arquivo com estrela",
    "collectFile": "Favoritos",
    "emptyFile": "Esta pasta está vazia",
    "loading": "Carregando para você"
  },
  "it": {
    "title": "Scegli la tua cartella cloud",
    "cloudDocuments": "Documenti Cloud",
    "cloudFile": "I miei documenti",
    "starFile": "File con asterisco",
    "collectFile": "Preferiti",
    "emptyFile": "Questa cartella è vuota",
    "loading": "Caricamento in corso"
  },
  "tw": {
    "title": "選擇雲文件",
    "cloudDocuments": "雲文檔",
    "cloudFile": "我的文件",
    "starFile": "已加星號的檔案",
    "collectFile": "我的最愛",
    "emptyFile": "此資料夾為空",
    "loading": "正在為您載入"
  },
  "kr": {
    "title": "클라우드 폴더 선택",
    "cloudDocuments": "클라우드 파일",
    "cloudFile": "내 문서",
    "starFile": "별표 표시된 파일",
    "collectFile": "즐겨찾기",
    "emptyFile": "해당 폴더에 아무것도 없습니다",
    "loading": "사용자를 위해 업로드 중"
  }
}
</i18n>
